import { LOCALES } from './locale';

export const ErrorText = {
  DEFAULT: `${LOCALES.SOMETHING_WENT_WRONG}. ${LOCALES.PLEASE_TRY_AGAIN_LATER}`,
  FILL_FORM: LOCALES.REQUIRED_FIELDS_MISSING,
  SUM_CONFLICT: LOCALES.TOTAL_AMOUNT_INCORRECT,
};
